// the code below can only be modified with commercial license
// if you want to use it in the commercial usage
// please contact us for more information: hello@silvertiger.ae

export const SILVERTIGER_CHAT_CLOUND = 'OXU Copilot Cloud';

export const BRANDING_NAME = 'OXU Copilot';
export const BRANDING_LOGO_URL = '/oten_copilot.png';

export const ORG_NAME = 'OXU Copilot';

export const BRANDING_URL = {
  help: undefined,
  privacy: undefined,
  terms: undefined,
};

export const SOCIAL_URL = {
  discord: 'https://discord.gg/',
  github: 'https://github.com/',
  medium: 'https://medium.com/',
  x: 'https://x.com/',
  youtube: 'https://www.youtube.com/',
};

export const BRANDING_EMAIL = {
  business: 'hello@silvertiger.ae',
  support: 'support@silvertiger.ae',
};
